import React from 'react';
const IconMiscMicFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 5.91C16 3.7 14.21 1.91 12 1.91C9.79 1.91 8 3.7 8 5.91V14.91H16V5.91Z" fill="#2D2E2E"/>
<path d="M18 10.91V14.67C18 15.9 17 16.91 15.76 16.91H8.24C7 16.91 6 15.91 6 14.67V10.91H4V14.67C4 17.01 5.9 18.91 8.24 18.91H11V21.91H13V18.91H15.76C18.1 18.91 20 17.01 20 14.67V10.91H18Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscMicFill;